<div class="flex flex-col gap-2 w-full min-w-[24rem]">
  <div class="flex flex-col items-start gap-2">
    @if (type === "default") {
      <p class="text-text-color text-sm font-normal font-['Inter'] leading-5">Are you sure you want to cancel this Travel Allowance application? Cancelled applications will remain in history and search results.</p>
    } @else if (type === "prepaid" ) {
      <p class="text-text-color text-sm font-normal font-['Inter'] leading-5">Prepayment was requested by the traveller on this TA, and the TA prepayment amount <b><i>has already been processed</i></b>.</p>
      <p class="text-text-color text-sm font-normal font-['Inter'] leading-5">Cancelling this TA now will require cancellation approval and will then be processed by Finance to recover the prepayment amount.</p>
    } @else if (type === "revert") {
      <p class="text-text-color text-sm font-normal font-['Inter'] leading-5">Reversing the cancellation returns this TA to <b><i>Travel Approved or Pending Acquittal</i></b>, depending on its travel dates.</p>
      <p class="text-text-color text-sm font-normal font-['Inter'] leading-5">The traveller may be required to acquit the TA again</p>
    } @else if (type === "cancelPrepayment" || type === "cancelPrepaymentProcessed") {
      <p class="text-text-color text-sm font-normal font-['Inter'] leading-5">This TA will no longer be treated as prepaid. It will be removed from Prepayment Requests and overpayments will no longer be calculated.</p>
      @if (type === "cancelPrepaymentProcessed") {
        <p class="text-text-color text-sm font-normal font-['Inter'] leading-5">This prepayment <b><i>has already been processed</i></b>. The payment record is kept, but if this TA is cancelled later it will not go through cancellation approval.</p>
      }
    } @else {
      <p class="text-text-color text-sm font-normal font-['Inter'] leading-5">Are you sure you want to cancel this Travel Allowance application? Cancelled applications will remain in history and search results.</p>
    }
  </div>

  <div class="flex flex-col gap-2">
    <label class="text-sm" for="cancel-ta-notes">
      {{promptLabel}}<span class="text-red-700 text-sm font-normal font-['Inter'] leading-5">*</span>
    </label>
    <textarea pTextarea
              id="cancel-ta-notes"
              data-testid="cancel-ta-notes"
              [(ngModel)]="notes"
              [placeholder]="placeholder"
              rows="4"
              pSize="small"
              [autoResize]="true"
              class="w-full"
    ></textarea>
  </div>

<!--  <div class="w-full h-[1px] bg-surface-200"></div>-->
  <div class="flex justify-end gap-2">
    <div class="bg-white rounded-lg">
      <p-button
        label="Close"
        severity="secondary"
        [outlined]="true"
        data-testid="cancel-ta-close"
        (onClick)="closeDialog()"
      />
    </div>
    <p-button
      [label]="acceptLabel"
      [severity]="type === 'revert' ? 'primary' : 'danger'"
      [disabled]="!canConfirm"
      data-testid="cancel-ta-confirm"
      (onClick)="confirmDialog()"
    />
  </div>
</div>
